import * as React from 'react'
import { ICoordinates } from '../../../types'
import { googleMapService } from '../../../services/GoogleMap'

export interface IETAProps {
  className?: string
  origin: ICoordinates | null
  destination: ICoordinates | null
}

export interface IETAState {
  eta: string | null
  fetching: boolean
}

class ETA extends React.Component<IETAProps, IETAState> {
  public state = {
    eta: null,
    fetching: false
  }

  public componentDidUpdate(prevProps: IETAProps) {
    const o1 = JSON.stringify(this.props.origin)
    const d1 = JSON.stringify(this.props.destination)
    const o2 = JSON.stringify(prevProps.origin)
    const d2 = JSON.stringify(prevProps.destination)

    if (!this.props.origin || !this.props.destination) {
      return
    }

    if (o1 !== o2 || d1 !== d2) {
      this.updateETA(this.props.origin, this.props.destination)
    }
  }

  public componentDidMount() {
    if (!this.props.origin || !this.props.destination) {
      return
    }
    this.updateETA(this.props.origin, this.props.destination)
  }

  public render() {
    if (!this.state.eta) {
      return <span className={this.props.className}>Unavailable</span>
    }

    return <span className={this.props.className}>{this.state.eta}</span>
  }

  private async updateETA(origin: ICoordinates, destination: ICoordinates) {
    this.setState({ fetching: true })
    console.log('calling google maps')
    const result = await googleMapService.getDriveTime(origin, destination)
    this.setState({ eta: result.text, fetching: false })
  }
}

export default ETA



// WEBPACK FOOTER //
// ./src/components/trips/trip-detail/ETA.tsx